module.exports = __webpack_public_path__ + "img/Produtos05.fw.8d455b6c.png";